import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Auth0LoginButton, buildAuth0PopupUrl, useAuth } from 'grabbitbot-legacy-ui'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, BRAND, POST_LOGIN_PATH } from '../../config'

// Signup is Auth0's Universal Login with `?signup=1` (screen_hint=signup
// server-side) — same popup handoff as LoginPage.
export function RegisterPage() {
  const navigate = useNavigate()
  const { status } = useAuth()

  useEffect(() => {
    if (status === 'authenticated') navigate(POST_LOGIN_PATH, { replace: true })
  }, [status, navigate])

  return (
    <div className="wnf-card wnf-card--auth">
      <h1>Create your {BRAND} account</h1>
      <p>
        <Auth0LoginButton
          popupUrl={buildAuth0PopupUrl(AUTH0_LOGIN_URL, { signup: true })}
          expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
          onSuccess={() => navigate(POST_LOGIN_PATH, { replace: true })}
        >
          Register
        </Auth0LoginButton>
      </p>
      <p>
        Already have an account? <Link to="/login">Sign in</Link>
      </p>
    </div>
  )
}
